var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShowSectionIndicator)?_c('div',{staticClass:"ur-section__indicator"},[_c('ur-section-row',_vm._l((12),function(i){return _c('ur-section-column',{key:i,attrs:{"possession":"1"}})}),1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }